const getters = {
  toekn: state => state.user.token
  // permissions: state => state.user.permissions
}

export default getters